const getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split("&"),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split("=");

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined
				? true
				: decodeURIComponent(sParameterName[1]);
		}
	}
};

const getUrlParameterJson = function getUrlParameterJson() {
	var search = window.location.search.substring(1);
	if (search !== "") {
		var urlParams = JSON.parse(
			'{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
			function (key, value) {
				return key === "" ? value : decodeURIComponent(value);
			}
		);
		// if (lsTest) {
		// 	localStorage.setItem("platform", urlParams.platform);
		// 	localStorage.setItem("payload", urlParams.payload);
		// 	localStorage.setItem("website_name", urlParams.website_name);
		// 	localStorage.setItem("url_params", urlParams.urlParams);
		// }

		return JSON.stringify(urlParams);
	}
};

const getUrlParameterValue = function getUrlParameterValue() {
	var search = window.location.search.substring(1);
	return search;
};

function lsTest() {
	var test = "test";
	try {
		localStorage.setItem(test, test);
		localStorage.removeItem(test);
		return true;
	} catch (e) {
		return false;
	}
}

const config = {
	shop: getUrlParameter("shop"),
	platform: getUrlParameter("platform"),
	wooType: getUrlParameter("woo_type"),
	payload: getUrlParameter("payload"),
	websiteUrl: getUrlParameter("website_url"),
	code: getUrlParameter("code"),
	scope: getUrlParameter("scope"),
	role: getUrlParameter("role"),
	checkLocalStorage: lsTest(),
	rootLink:
		getUrlParameter("platform") === "WOO_COMMERCE"
			? process.env.REACT_APP_ROOT_LINK + "woocommerce/"
			: process.env.REACT_APP_ROOT_LINK,
	helpSupportUrl:
		"https://apps.omegatheme.com/helpdesk/server/processDataHelp.php",
	urlParams: getUrlParameterJson(),
	urlParamsValue: getUrlParameterValue(),
	pathName:
		getUrlParameter("platform") === "WOO_COMMERCE"
			? process.env.REACT_APP_PATH_NAME_WOO
			: process.env.REACT_APP_PATH_NAME,
	// pathName: "/add-paypal-tracking/front/build",
	mode: process.env.REACT_APP_MODE,
	apiKey: process.env.REACT_APP_API_KEY,
	redirectUri: process.env.REACT_APP_ROOT_LINK + "get_code.php",
	appName: "Synctrack - Add Tracking Info",
	liveAppUrl: "https://apps.shopify.com/synctrack",
	dashboardNoti: "Make sure you know how these changes affect your store.",
};
export default config;
